import React from "react";
import DisplayMedia from "../components/media-display";
import AppBarBar from "../components/AppBar";
import FooterPage from "../components/FooterPage";

const items = [
  { res: "media/img1.jpeg", isImg: true, description: "" },
  { res: "media/img2.jpeg", isImg: true, description: "" },
  {
    res: "media/vid1.mp4",
    isImg: false,
    description:
      "Root vegetables, cereals, plantains, green bananas, pulses, lemons processed into pregellitised form for longer term storage that can be used to produce FIGHN fufu or gruel flours.",
  },
  { res: "media/img3.jpeg", isImg: true, description: "" },
];

function GalleryImages() {
  return (
    <div className="bg-canvas min-h-screen">
      <AppBarBar />

      <div className="bg-forest text-canvas pt-32 pb-16 sm:pt-40 sm:pb-20">
        <div className="max-w-6xl mx-auto px-6 sm:px-8">
          <p className="text-grain font-semibold text-xs uppercase tracking-[0.2em] mb-3">
            Gallery
          </p>
          <h1 className="font-display text-4xl sm:text-5xl mb-4 max-w-xl">
            A closer look at Fighn
          </h1>
          <p className="text-canvas/70 max-w-lg">
            From raw cereals and pulses to the pregelatinized flour that
            reaches your kitchen — here's what goes into every batch.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-20">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <DisplayMedia
              key={index}
              src={item.res}
              isImg={item.isImg}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <FooterPage preFooter={false} />
    </div>
  );
}

export default GalleryImages;